import { API, Auth } from 'aws-amplify';

// function fetchAPI(url, method, body, headers) {
//     return fetch(url, {
//         method: method,
//         mode: 'cors',
//         redirect: 'follow',
//         body: body ? JSON.stringify(body) : body,
//         headers: new Headers({ 'content-type': 'application/json' }),
//     }).then((response) => {
//         if (response.ok) {
//             return response.json();
//         } else {
//             return response.json().then((d) => Promise.reject(d));
//         }
//     });
// }
async function getToken() {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
}
let allProducts = [];

export function invalidateCache() {
    allProducts = [];
}

export async function getAllNoPage() {
    await getAll();
    return allProducts;
}

export async function getAllNoPaging() {
    if (allProducts.length === 0) {
        allProducts = await API.get('orders', `/prod/products/all`, {
            headers: {
                Authorization: await getToken(),
            },
        });
        allProducts.sort((a, b) =>
            a.dateTo > b.dateTo || (a.dateTo !== undefined && b.dateTo === undefined) ? -1 : b.dateTo > a.dateTo || (b.dateTo !== undefined && a.dateTo === undefined) ? 1 : 0
        );
    }
    return allProducts;
}

export async function getAll(page, pageSize, search) {
    if (allProducts.length === 0 || page === 0 || page === undefined) {
        allProducts = await API.get('orders', `/prod/products/all`, {
            headers: {
                Authorization: await getToken(),
            },
        });
        allProducts.sort((a, b) =>
            a.dateTo > b.dateTo || (a.dateTo !== undefined && b.dateTo === undefined) ? -1 : b.dateTo > a.dateTo || (b.dateTo !== undefined && a.dateTo === undefined) ? 1 : 0
        );
    }

    if (search) {
        search = search.toLowerCase();
        let filteredData = allProducts.filter((line) => {
            for (let k of Object.keys(line)) {
                if (typeof line[k] === 'string') {
                    if (line[k].toLowerCase().indexOf(search) !== -1) return true;
                } else if (typeof line[k] === 'number') {
                    if (line[k].toString().indexOf(search) !== -1) return true;
                }
            }
            return false;
        });
        return { data: filteredData.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: filteredData.length };
    }

    return { data: allProducts.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: allProducts.length };
}

export async function uploadFile(platformId, imageType, base64Data) {
    // let data = await API.put('cc', `/upload-file/${platformId}/${imageType}`, {
    //     headers: {
    //         Authorization: await getToken(),
    //     },
    //     body: { data: base64Data },
    // });

    // return data;
    return {};
}

export async function updateProduct(product, image) {
    // let data = await API.put('cc', `/upload-file/${platformId}/${imageType}`, {
    //     headers: {
    //         Authorization: await getToken(),
    //     },
    //     body: { data: base64Data },
    // });

    allProducts = await API.put('orders', `/prod/product`, {
        headers: {
            Authorization: await getToken(),
        },
        body: { product, image },
    });

    // return data;
    return {};
}

export async function addProduct(product) {
    // let data = await API.put('cc', `/upload-file/${platformId}/${imageType}`, {
    //     headers: {
    //         Authorization: await getToken(),
    //     },
    //     body: { data: base64Data },
    // });

    allProducts = await API.put('orders', `/prod/product/add`, {
        headers: {
            Authorization: await getToken(),
        },
        body: { product },
    });

    // return data;
    return {};
}

// export async function getAll() {
//     return await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/products', 'GET');
// }
